<template>
  <div class="container">
    <b-row>
      <b-col>
        <Visualizar />
      </b-col>
    </b-row>

    <b-row class="row-button" v-if="!readOnly">
      <b-col class="one">
        <Help
          :title="title"
          :text="text"
          :text_Two="text_Two"
          :text_One="text_One"
          :text_three="text_three"
          :text_four="text_four"
          :text_five="text_five"
          :text_six="text_five"
          :text_seven="text_seven"
          :text_eight="text_eight"
          :text_nine="text_nine"
        />
      </b-col>
      <b-col class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          v-if="userPermissions"
          @click="guardarBorrador"
        >
          Guardar como borrador
        </b-button>
        <b-button
          @click="guardarFinalizado"
          pill
          variant="primary"
          class="btn-two"
          v-if="userPermission"
        >
          Guardar y finalizar
        </b-button>
      </b-col>
    </b-row>

    <h5 class="title">Evaluaciones - Informe Programas</h5>

    <b-row v-if="userPermissions" class="">
      <b-form-checkbox
        style="display:flex;   justify-content: flex-end; "
        v-model="checked"
        name="check-button"
        switch
      >
        <span class="span" v-if="checked">No Aplica</span>
        <span class="span" v-else>No Aplica</span>
      </b-form-checkbox>
    </b-row>

    <div v-if="checked">
      <AlertError />
    </div>

    <div v-else>
      <List
        :itemList="itemList"
        :addItemList="addItemList"
        :removeItem="removeItem"
        :readOnly="readOnly"
      />
    </div>
  </div>
</template>

<script>
import Visualizar from "../../../../components/button/escritorio/Visualizar.vue";
import Help from "../../../../components/tools/Modal.vue";
import List from "./Tablas/List";
import axios from "axios";
import Swal from "sweetalert2";
import { showAlert } from "../../../../components/tools/utils";
import { mapState } from "vuex";
import AlertError from "../../../../components/error/AlertError.vue";
export default {
  components: {
    Visualizar,
    Help,
    List,
    AlertError,
  },
  data() {
    return {
      itemList: [],
      nombre: "evaluaciones",
      checked: true,
      userPermission: true,
      userPermissions: true,
      datosUser: null,
      title: "Informe programas",
      text:
        "Las instituciones deben reportar las evaluaciones institucionales y de programas públicos que se hayan desarrollado dentro del período 2019 – 2020 incluyendo aquellas que sean parte del Programa de Evaluación de DIPRES.",
      text_Two:
        "Los procesos evaluativos deberán ser informado por el Servicio en el aplicativo BGI 2020.",
      text_One: "Descripción de cada columna:",
      text_three:
        "Tipo de la evaluación: Si corresponde a evaluaciones y/o estudios a programas de la cartera como, por ejemplo: de implementación (general o de aspectos específicos del programa), construcciones o mediciones de línea base, satisfacción usuaria, de resultados intermedios o finales, efectos, calidad, impacto, entre otros.",
      text_four:
        "Programa/Institución: Se señala el o los programas de la Oferta Programática vigente de la institución que fueron parte de la evaluación. En caso de ser una evaluación institucional se debe señalar el nombre de la institución.",
      text_five: "Año: Año de inicio de la evaluación",
      text_six:
        "Estado: Corresponde al estado en que se encuentra la evaluación. Puede ser finalizada o en desarrollo.",
      text_seven:
        "Monto: Recursos utilizados para llevar a cabo la evaluación. Si la evaluación es de carácter interno, favor señalar un monto estimativo.",
      text_eight:
        "Link de descarga: En caso de que el estado sea finalizada/publicada señalar link de acceso al documento.",
      text_nine:
        "Evaluación Dipres: Se señala con un SI o NO si corresponde a una evaluación Dipres.",
    };
  },
  props: ["readOnly"],
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    addItemList: function() {
      const toAddObj = {
        tipoEvaluacion: "",
        programa: "",
        anio: "",
        estado: "",
        monto: "",
        link: "",
        evaluacion: "",
      };
      this.itemList.push(toAddObj);
    },
    removeItem: function(index) {
      const pos = this.itemList.indexOf(index);

      this.itemList.splice(pos, 1);
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.itemList,
          aplica: this.checked,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      const toSend = this.buildData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.itemList,
              aplica: this.checked,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );

          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },
    guardarFinalizado: async function() {
      const toSend = this.buildData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.itemList,
                  aplica: this.checked,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Guardado y finalizado exitosamente.",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "evaluaciones",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.checked = res.data.info.aplica;
        if (res.data.info.content) {
          this.itemList = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        console.log("To send", toSend);
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const relacionUs = this.usuario.servicios.find(
          (s) => s.id === this.$route.params.idServicio
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);
        // Guardar Borrador Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Guardar y finalizar Encargado BGI
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Guardar y finalizar Jefe de Servicio
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermission = true;
        }
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          //Guardar funcionario
          this.userPermissions = false;
        }

        //Guardar Borrador Jefe de Servicio

        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        } else if (
          this.datosUser.a === undefined ||
          (this.datosUser.siguienteAccion === "jefe_servicio" &&
            relacionUs.rolId === 3)
        ) {
          this.userPermissions = true;
        }
        console.log("Estado buttonssssss", this.userPermissions);
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
  },
  mounted() {
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  text-align: center;
  color: #052333;
  font-size: 1.6rem;
}
h5 {
  font-weight: bold;
  text-align: center;
}

.row-button {
  margin-bottom: 30px;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
